{
  "home-page": {
    "meta": {
      "title": "Beauty Booking",
      "description": "online booking, nails discount, nails offers, nails deals, eyebrow discount, eyebrow offers, eyebrow deals, eyelashes discount, eyelashes offers, eyelashes deals, PMU discount, PMU offers, PMU deals"
    },
    "text": {
      "book-appointment-again": "Book new appointments in the salons you have visited"
    }
  }
}
